//export const properties = {    
const properties = {    
    productionUrl: "https://fascicolo.xyz",
    //productionUrl: "https://fascicolo.compagniadisanpaolo.it",
    version:"6.43",
    //verboseLog: 1,
    verboseLog: 0,
    //gsfActive: 0,
    gsfActive: 1,
    //chatbotActive: 0,
    chatbotActive: 1,
    //productionUrlSuffix: "/php_demo"
    productionUrlSuffix: "/php"
    
};

module.exports = { properties };